import React, { useState, useEffect } from 'react'
import { Btn, CustomDropdown, CustomModal } from '../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { errorHandler } from '../../../../services/util/error.service'
import * as PickingHttp from '../../../../services/api/https/picking/picking.http'

const ModalClientesSemRotaDeEntrega = React.memo(
  ({ clientesSemRotaDeEntrega, rotasEntrega, isVisible, onClose, onResponse }) => {
    // Hooks
    const [rows, setRows] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
      const _rows = clientesSemRotaDeEntrega.map(c => ({ ...c, rota: '' }))
      setRows(_rows)
    }, [clientesSemRotaDeEntrega])

    //Events
    const onBtnSalvar = async () => {
      try {
        setIsLoading(true)
        // Building Associacoes
        const associacoes = []
        rows.forEach(r => {
          const { rota, client_id } = r
          if (rota !== '') associacoes.push({ client_id, rota_id: rota.rota_id })
        })
        if (associacoes.length === 0) throw new Error('Nenhuma rota foi associada')

        // Enviando as associacoes
        await PickingHttp.associarClientesAhRotaDeEntrega(associacoes)

        setIsLoading(false)
        onResponse('success')
      } catch (e) {
        setIsLoading(false)
        onResponse('error', errorHandler(e))
      }
    }

    const onRotaChange = (cliente, rota) => {
      setRows(prevRows => {
        const { client_id } = cliente
        const index = prevRows.findIndex(r => r.client_id === client_id)
        if (index !== -1) {
          prevRows[index].rota = rota
        }
        return [...prevRows]
      })
    }

    //Render
    return (
      <CustomModal
        width={'70%'}
        header={'Clientes sem Rota de Entrega Associada'}
        isVisible={isVisible}
        onClose={onClose}
      >
        <div className="p-grid">
          <div className="p-col-12">
            <Btn onClick={onBtnSalvar} isLoading={isLoading}>
              Salvar
            </Btn>
          </div>
          <div className="p-col-12">
            <DataTable value={rows} paginator={true} rows={5}>
              <Column field={'nomeFantasia'} header={'Cliente'} />
              <Column field={'cidade'} header={'Cidade'} />
              <Column field={'bairro'} header={'Bairro'} />
              <Column
                header={'Rota'}
                body={row => (
                  <CustomDropdown
                    value={row.rota}
                    filter={true}
                    onChange={value => onRotaChange(row, value)}
                    optionLabel={'rota_nome'}
                    options={rotasEntrega}
                  />
                )}
              />
            </DataTable>
          </div>
        </div>
      </CustomModal>
    )
  },
)

export default ModalClientesSemRotaDeEntrega
